import { Box, ScopedCssBaseline, Skeleton } from "@mui/material";
import "./TablePlaceholder.scss";

export default function TablePlaceholder() {
    return (
        <ScopedCssBaseline>
            <Box className="tablePlaceholder">
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
                <Skeleton animation="wave" width="100%" className="tablePlaceholderLine" />
            </Box>
        </ScopedCssBaseline>
    );
}
